// add the recaptcha challenge container and the evidon banner as shards so they are clickable when a modal is open
export const getModalShards = () => {
  if (typeof document === 'undefined') return [];

  const recaptchaContainer = document.querySelector('.recaptcha-challenge-container')?.parentNode;
  const evidonBanner = document.querySelector('.evidon-banner');

  return [recaptchaContainer, evidonBanner].filter(Boolean) as HTMLElement[];
};
